import styled from 'styled-components';

import { getDegreeOfRotation } from '@/helpers/wheel';

import { device } from '@/styles/helpers';

export const ScWheelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: 482px;
  height: 482px;
  margin: 39px auto;

  @media (${device.mobile}) {
    width: 325px;
    height: 325px;
  }

  @media (min-width: 320px) and (max-width: 359px) {
    width: 288px;
    height: 288px;
  }

  @media (${device.mobile}) {
    margin: 45px auto 39px;
  }

  &,
  & .inner {
    position: relative;
    border-radius: 50%;
    z-index: 1;
  }

  & .inner {
    width: 100%;
    height: 100%;
    margin: 0 auto;

    .wheelImage {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      @media (${device.mobile}) {
        width: 343px;
        height: 343px;
      }
      @media (min-width: 320px) and (max-width: 359px) {
        width: 305px;
        height: 305px;
      }
    }
  }
`;

interface ScWheelPrizesProps {
  isSpinning: boolean;
  winningPrizeIndex: number;
  totalPrizes: number;
}

export const ScWheelPrizes = styled.div<ScWheelPrizesProps>`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 50%;
  background: ${({ theme }) => theme.green5Color};
  transform: ${({ isSpinning, winningPrizeIndex, totalPrizes }) =>
    isSpinning
      ? `rotate(${
          90 + 360 * 10 + (360 / totalPrizes) * winningPrizeIndex * -1
        }deg)`
      : `rotate(${89 - getDegreeOfRotation(totalPrizes, 1) / 2}deg)`};
  transition: transform 7s;
`;

export const ScWheelArrow = styled.div<{ arrowImg: string }>`
  position: absolute;
  z-index: 3;
  width: 78px;
  height: 78px;
  right: -25px;
  top: 50%;
  transform: translateY(-50%);
  background: url(${({ arrowImg }) => arrowImg}) center no-repeat;
  background-size: cover;

  @media (${device.mobile}) {
    width: 52px;
    height: 52px;
    right: -20px;
  }

  &::after {
    position: absolute;
    display: block;
    content: '';
    background: transparent;
    top: -2px;
    left: -2px;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
  }
`;
